export default function registerOrderObjectByFilter(module) {
    /**
     * Registers a custom AngularJS filter named 'orderObjectBy' to the provided module.
     * This filter sorts an array of objects by a specified field and optionally reverses the order.
     * 
     * @param {object} module - The AngularJS module to which the filter will be registered.
     */
    module.filter('orderObjectBy', function() {
        /**
         * Returns the filter function that sorts an array of objects by a specified field.
         * 
         * @param {Array} items - The array of objects to be sorted.
         * @param {string} field - The field by which the objects should be sorted.
         * @param {boolean} reverse - If true, the sorted array will be reversed.
         * @returns {Array} - The sorted array of objects.
         */
        return function(items, field, reverse) {
            if (!Array.isArray(items)) {
                return items;
            }

            // Sort the array based on the specified field
            let filtered = items.slice().sort((a, b) => {
                if (a[field] > b[field]) return 1;
                if (a[field] < b[field]) return -1;
                return 0;
            });

            // Reverse the array if the reverse flag is true
            if (reverse) {
                filtered.reverse();
            }

            return filtered;
        };
    });
}